/* global Flickity, jQuery: false */

function scrolledWindow() {

	'use strict';

	let body = $('body');

	let scroll = $( window ).scrollTop();

	if (scroll >= 150 || window.innerWidth < 992) {
		body.addClass('scrolled');
	} else {
		body.removeClass('scrolled');
	}

}

function masonryGalleryInitialise() {
	let $gallery = $('.masonry-gallery');
	if ($gallery.length > 0) {
		if ($gallery.data('isotope')) {
			/**
			 * init Isotope after all images have loaded
			 */
			$gallery.imagesLoaded().progress( function() {
				$gallery.isotope('layout');
			});

			/**
			 * Filter items on button click
			 */
			$('.masonry-gallery-filters').on('click', 'li a', function() {
				if (typeof preloader === 'function') {
					$gallery.find('.gallery-item').preloader({
						loader: '/app/themes/nelios-base/svg/loader/preloader.svg',
						fadeIn: 300,
						delay: 100
					});
				}

				$gallery.isotope({
					filter: $(this).attr('data-filter')
				});
			});
		} else if ($gallery.data('masonry')) {
			$gallery.imagesLoaded().progress( function() {
				$gallery.isotope('layout');
			});
		}
	}
}

(function($){

	'use strict';

	/**
	 * breakpoints
	 */
	window.width = $(window).width();
	window.windowInnerWidth = window.innerWidth || $(window).width();
	window.windowInnerHeight = window.innerHeight || $(window).height();

	if (window.width !== window.windowInnerWidth) {
		window.scrollBar = true;
	}

	$(document).ready( () => {
		/**
		 * Global Variables
		 *
		 */

		let body = $(document.body);

		/**
		 * Use it if you want to render some function or plugin or variable in certain page.
		 * If you want to use on more than one use the page and logical OR (||) in JavaScript eg. 'page.simple || page.room'
		 *
		 * If page object is inside document.ready it is not visible outside of it.
		 *
		 * */
		window.page = {
			all          : true, // Pass on every page
			roomList     : body.hasClass('page-template-rooms'),
		};

		scrolledWindow();

		masonryGalleryInitialise();

		$('html').connector({
			connector: '.menu-connector',
			toggleClassName: 'menu-active',
			// removeSiblings: true,
			// triggerType: 'click',
			// toggleClassName: 'active',
			// atLeastOneEnabled: true,
			breakpoint: true,
		});

		var readMoreToggle = $('.read-more-toggle');
		if(readMoreToggle.length > 0){
			readMoreToggle.readMoreToggler();
		}

		//Slide Drag and Open Photoswipe Conflict Removal
		let gallerySliders = document.querySelectorAll('.room-gallery, .page-gallery, .gallery');
		[...gallerySliders].forEach((slider) => {
			let flkty = Flickity.data(slider);
			flkty.on('dragStart', function () {
				this.cells.forEach((cell) => {
					cell.element.style.pointerEvents = 'none';
				});
			});
			flkty.on('dragEnd', function () {
				this.cells.forEach((cell) => {
					cell.element.style.pointerEvents = 'all';
				});
			});
		});


		/**
		 * Element Filtering
		 */
		let filters = $('.filters');
		if (filters.length > 0) {
			let listingWrapper = $('.listing-wrapper');
			listingWrapper.imagesLoaded(
				function () {
					listingWrapper.isotope(
						{
							itemSelector: 'article',
						}
					);
				}
			);

			filters.on('click', 'a', function () {
				let filterValue = $(this).attr('data-filter');
				listingWrapper.isotope(
					{
						filter: filterValue
					}
				);
			});
		}
	});


	let flickityOptions = {
		contain: true,
		autoPlay: false,
		cellSelector: ".gallery-item",
		prevNextButtons: false,
		pageDots: false,
		draggable: ">1",
		wrapAround: false,
		imagesLoaded: true
	};
	let photoswipeOptions = {
		closeOnScroll: true,
			escKey: true,
			arrowKeys: true,
			loop: true,
			history: true,
			focus: true,
			modal: true,
			showHideOpacity: true,
			closeEl: true,
			captionEl: true,
			fullscreenEl: true,
			zoomEl: true,
			counterEl: true,
			arrowEl: true,
			preloaderEl: true,
			bgOpacity: true
		};

	let wp_gallery = document.querySelectorAll('.gallery');

	wp_gallery.forEach( (gallery) => {
		new Flickity(gallery,flickityOptions);

		gallery.classList.add("mouse-hover");
		let galleryUrls = gallery.querySelectorAll("a");
		galleryUrls.forEach( (urlTag,index) => {
			let imgProps = urlTag.querySelector('img');
			urlTag.setAttribute('href',imgProps.src);
			urlTag.setAttribute('data-width',imgProps.getAttribute('width'));
			urlTag.setAttribute('data-height',imgProps.getAttribute('height'));
			urlTag.setAttribute('data-title',imgProps.alt);
			urlTag.setAttribute('data-slug',imgProps.alt);
			urlTag.setAttribute('data-index',index);
			gallery.setAttribute('data-photoswipe-options',photoswipeOptions);


			/** todo Find a way to get the biggest image src and sizes for photoswipe**/

			// const img = new Image();
			// img.src = $(imgProps).attr('srcset').split(',').pop().trim().split(' ')[0];
			// img.addEventListener("load", function() {
			// 	console.log( this.naturalWidth +' '+ this.naturalHeight );
			// });
		});
	});


	/**
	 * Mouse Follower Functionality
	 */
	let $mouseFollower = $('.mouse-follower');

	const mouseFollower = document.querySelector('.mouse-follower');

	let mouseX = 0;
	let mouseY = 0;

	let ballX = 0;
	let ballY = 0;

	let speed = 0.1;

	function mouseFollowerFunc() {

		let distX = mouseX - ballX;
		let distY = mouseY - ballY;

		ballX = ballX + (distX * speed);
		ballY = ballY + (distY * speed);

		mouseFollower.style.left = ballX + 'px';
		mouseFollower.style.top = ballY + 'px';

		requestAnimationFrame(mouseFollowerFunc);
	}

	$(document).one('mousemove', function() {
		mouseFollowerFunc();
	});

	document.addEventListener('mousemove', function(event){
		mouseX = event.clientX;
		mouseY = event.clientY;
	});

	/**
	 * Mouse Follower Interactions
	 */
	$('.mouse-hover').hover(function() {
		if ( ! $mouseFollower.hasClass('mouse-follower-drag')) {
			$mouseFollower.addClass('mouse-follower-drag');
		}
	}, function() {
		$mouseFollower.removeClass('mouse-follower-drag');
	});

	let parallaxElements = $('*[data-parallax-background-image-url]');

	if (parallaxElements.length > 0) {
		parallaxElements.each(function () {
			let parallaxElement = $(this);
			let parallaxImageUrl = parallaxElement.attr('data-parallax-background-image-url');

			if (parallaxImageUrl) {
				parallaxElement.css('background-image', 'url(' + parallaxImageUrl + ')');
			}
		});
	}

}(jQuery));

$( window ).on('resize orientationchange scroll', function() {
	scrolledWindow();
});

$( window ).on('resize orientationchange', function() {
	let readMoreToggle = $('.read-more-toggle');
	if (readMoreToggle.length > 0) {
		readMoreToggle.each(function() {
			$( this ).readMoreToggler();
		});
	}
}).trigger('resize');
